import axios from 'axios';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

const baseURL = `${process.env.REACT_APP_BACKEND_API}system/override`;

function getSessionHeaders() {
  const headers = {
    'content-type': 'application/json',
  };

  try {
    const raw = sessionStorage.getItem(LOGGEDIN_USER_DATA);
    const userData = raw ? JSON.parse(raw) : null;
    const token = userData && userData.token;
    if (token) {
      headers.authorization = `Bearer ${token}`;
      headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    // Keep fail-safe: proceed without auth header when session payload is malformed.
  }

  return headers;
}

export async function searchOverrideDelivery(dr_no) {
  const url = `${baseURL}/search?type=delivery&dr_no=${encodeURIComponent(dr_no)}`;
  const response = await axios.get(url, {
    headers: getSessionHeaders(),
  });
  return response.data;
}

export async function searchOverrideInvoice(invoice_no) {
  const url = `${baseURL}/search?type=invoice&invoice_no=${encodeURIComponent(invoice_no)}`;
  const response = await axios.get(url, {
    headers: getSessionHeaders(),
  });
  return response.data;
}

export async function searchInvoiceTransactionAudit(invoice_no) {
  const url = `${process.env.REACT_APP_BACKEND_API}invoice/search/?invoice_no=${encodeURIComponent(
    invoice_no,
  )}&customer=&agent=&start_date=&end_date=`;
  const response = await axios.get(url, {
    headers: getSessionHeaders(),
  });
  return response.data;
}

export async function searchOverridePayment(payment_no) {
  const url = `${baseURL}/search?type=payment&or_no=${encodeURIComponent(payment_no)}`;
  const response = await axios.get(url, {
    headers: getSessionHeaders(),
  });
  return response.data;
}

export async function updateOverrideStatus(payload) {
  let overrideResponse = {};
  try {
    const response = await axios({
      method: 'POST',
      url: `${baseURL}/update`,
      data: payload,
      headers: getSessionHeaders(),
    });
    overrideResponse = response;
  } catch (error) {
    throw error;
  }
  return overrideResponse;
} 
